import { createStyles, makeStyles, Theme } from '@material-ui/core';
import { RegistroStatus } from 'common/genericTypes';
import { GridLocaleText } from '@mui/x-data-grid';

export const localizedTextsMap = {
  toolbarExport: 'Exportar',
  toolbarExportCSV: 'Exportar em CSV',
  toolbarExportPrint: 'Imprimir',
  columnMenuUnsort: 'Não classificado',
  columnMenuSortAsc: 'Ordem crescente',
  columnMenuSortDesc: 'Ordem decrescente',
  columnMenuFilter: 'Filtro',
  columnMenuHideColumn: 'Ocultar',
  columnMenuShowColumns: 'Mostrar colunas',
  columnsPanelHideAllButton: 'Ocultar todos',
  columnsPanelShowAllButton: 'Exibir todos',
  columnsPanelTextFieldLabel: 'Pesquisar coluna',
  columnsPanelTextFieldPlaceholder: 'Nome da coluna',
  columnHeaderSortIconLabel: 'Ordernar',
  MuiTablePagination: {
    labelRowsPerPage: 'Linhas por página',
    labelDisplayedRows: ({ from, to, count }) => `${from} - ${to} de ${count}`,
  },
} as Partial<GridLocaleText>;

export const useStyles = (status: RegistroStatus) =>
  makeStyles((theme: Theme) => {
    const colors: { [key: string]: string } = {
      [RegistroStatus.EmAnalise]: theme.palette.warning.main,
      [RegistroStatus.Aprovado]: theme.palette.primary.main,
      [RegistroStatus.Reprovado]: theme.palette.error.main,
      [RegistroStatus.AguardandoCorrecao]: theme.palette.warning.main,
      [RegistroStatus.Excluido]: theme.palette.error.main,
      [RegistroStatus.AguardandoAprovacaoEdicao]: theme.palette.warning.main,
      [RegistroStatus.AguardandoAprovacaoAditamento]: theme.palette.warning.main,
    };
    return createStyles({
      icon: {
        color: colors[status] ?? theme.palette.grey,
        marginRight: 10,
      },
      wrapTxt: {
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
      },
      textButton: {
        padding: '0 0 0 0',
        marginRight: '10px',
        borderBottom: `1px solid ${theme.palette.primary.main}`,
        borderRadius: 0,
      },
    });
  });

export const componentsPropsValues = { toolbar: { csvOptions: { allColumns: true, utf8WithBom: true } } };

export const rowsPerPageOptionsValues = [5, 10, 20, 40, 60, 100, 500, 750, 1000];

export { csvOptionsValues } from './csvExportOptions';

export const printOptionsValues = { disableToolbarButton: true };
